






















































import {Vue, Component, Prop, Watch, Ref} from 'vue-property-decorator'
import { PushTemplateItemImpl } from '@/store/templates/types';
import { pushImagePreviewUrl } from '@/utils/push-image-preview-url';

@Component
export default class AndoroidPushPreview extends Vue {
  @Prop() template!: PushTemplateItemImpl | undefined;

  collapsed = false

  collapseToggle() {
    this.collapsed = !this.collapsed
  }

  pushImagePreviewUrl = pushImagePreviewUrl;

}
